import { Switch as HeadlessSwitch } from '@headlessui/react';
import { clsx } from 'clsx';

export interface ToggleProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function Toggle({ id, checked, onChange, disabled = false, className }: ToggleProps) {
  return (
    <HeadlessSwitch
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={clsx(
        'relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200',
        'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-dark-900',
        checked ? 'bg-primary-600 dark:bg-primary-500' : 'bg-gray-200 dark:bg-dark-700',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
    >
      <span className="sr-only">Toggle</span>
      <span
        className={clsx(
          'inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200',
          checked ? 'translate-x-6' : 'translate-x-1'
        )}
      />
    </HeadlessSwitch>
  );
}
